import { REDUX_SLICE } from '../constants';
import { networkApi } from '../services/network.service';
import { nodeApi } from '../services/node.service';
import { appSlice } from '../slices/app.slice';

export const reducer = {
  [REDUX_SLICE.APP]: appSlice.reducer,
  [REDUX_SLICE.NODE_API]: nodeApi.reducer,
  [REDUX_SLICE.NETWORK_API]: networkApi.reducer,
};
